import PinTransferDataResponse, { getDefaultState as getDefaultUserSettingsMappedData } from './dealerTransferResponse';
import t from 'tcomb';

const PinTransferDataCollections = t.list(PinTransferDataResponse, 'PinTransferDataResponse');

export const getDefaultState = () => new PinTransferDataCollections(
    [getDefaultUserSettingsMappedData()],
);
export default PinTransferDataCollections;
